module.exports = __webpack_public_path__ + "img/dy04.88fe17b5.png";